export const borderRadius = ".28571429rem";
export const small = "1.5rem";
export const halfSmall = ".78571429rem";
export const maxWidth = 1800;
export const height = "50px";
